<script>
  import { getContext } from 'svelte';
  import { useLocation } from 'svelte-navigator';

  import { appSettingsStore } from '@client/stores/page-settings';

  const { basepath } = getContext('config');
  const location = useLocation();

  $: $location, ($appSettingsStore.lastPageUrl = `${basepath}${$location.pathname}`);
</script>
